export const ReturnIsAllLoaded = (isAllLoaded: boolean[]):boolean => {
  let isAllAsyncLoaded: boolean = true;
  isAllLoaded.map((value, index) => {
    if(!value) {
      isAllAsyncLoaded = false;
    }
  });
  return isAllAsyncLoaded;
}